// Recursively extract primitive values from an object
export function flattenValues(obj: unknown): string[] {
  if (obj == null) return [];
  if (typeof obj !== "object") return [String(obj)];
  return Object.values(obj).flatMap((val) => flattenValues(val));
}
